import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareNextgenRedirectRoute: InvariantJiraRoute = {
	name: 'software-nextgen-redirect',
	path: '/secure/NextGen.jspa',
};
